<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showNewMotivo"
      scrollable
      no-close-on-backdrop
      title="Nuevo reglamento "
      cancel-variant="outline-secondary"
    >
      <b-row class="mt-1">
        <b-col md="12">
          <div class="form-label-group">
            <b-form-input
              id="floating-articulo"
              placeholder="Ingrese Articulo Ej: ART. 24 LIT A T.R X CV"
              v-model="motivoSelected.motivo"
            />
            <label for="floating-articulo">Articulo</label>
          </div>
        </b-col>

        <b-col md="12" class="mt-1">
          <div class="form-label-group">
            <b-form-textarea
              id="textarea-auto-height"
              placeholder="Detalle del articulo"
              rows="2"
              size="sm"
              max-rows="3"
              v-model="motivoSelected.detalle"
            />
            <label for="floating-auto-height">Detalle</label>
          </div>
        </b-col>
        <b-col md="12" class="mt-1">
          <div class="form-label-group">
            <b-form-textarea
              id="textarea-auto-height"
              placeholder="Ingrese en pocas palabras el detalle (max 40 caracteres)"
              rows="2"
              size="sm"
              max-rows="3"
              maxlength="40"
              v-model="motivoSelected.detalle_acta"
            />
            <label for="floating-auto-height">Detalle Corto Para Acta de Sanciones(max 40 caracteres)</label>
          </div>
        </b-col>
        <b-col md="7" class="mt-1">
          <div class="form-label-group">
            <b-form-input
              id="floating-partidos"
              type="number"
              placeholder="# Partidos de suspensión "
              v-model="motivoSelected.total_partidos"
            />
            <label for="floating-valor"
              >Total de partidos de suspensión(Opcional)</label
            >
          </div>
        </b-col>
        <b-col md="5" class="mt-1">
          <div class="form-label-group">
            <b-form-input
              id="floating-valor"
              type="number"
              placeholder="Valor"
              v-model="motivoSelected.valor"
            />
            <label for="floating-valor">Valor(Opcional)</label>
          </div>
        </b-col>
        <b-col md="12">
          <b-form-checkbox
            :disabled="accion == 'i' ? false : true"
            v-model="motivoSelected.tipo_partido_boolean"
          >
            <p style="font-size:12px;color:gray !important">
              Marcar como sancion tipo partido
            </p>
          </b-form-checkbox>
        </b-col>
        <template v-if="motivoSelected.tipo_partido_boolean">
          <b-col md="12">
            <span style=""
              >Selecciona una opción solamente si el artículo ingresado afectará
              directamente al partido (Opcional)</span
            >
          </b-col>
          <b-col md="12" class="mt-1">
            <b-form-radio
              :disabled="accion == 'i' ? false : true"
              v-for="opcion in opciones"
              :key="opcion.id"
              style="text-align:left !important; margin-top:5px"
              name="accion-baja"
              :value="opcion.id_opcion_baja"
              v-model="motivoSelected.id_opcion_baja"
            >
              <span style="font-size:11px; ">{{ opcion.descripcion }} </span>
            </b-form-radio>
          </b-col>
        </template>
      </b-row>
      <br />
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col class="mt-1">
              <template v-if="!showLoading">
                <b-button
                  v-if="
                    USER().rol === `${ROLES.ADMIN}` ||
                      USER().rol === `${ROLES.SUPER}` ||
                      USER().rol === `${ROLES.SANCIONES}`
                  "
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="float-right"
                  @click="insertNuevoMotivoReglamento(accion)"
                >
                  <span v-if="accion == 'i'">Guardar</span>
                  <span v-if="accion == 'u'">Actualizar</span>
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="float-right mr-1"
                  @click="onlyClose"
                >
                  Cancelar
                </b-button>
              </template>
              <div v-if="showLoading" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-col>
          </b-row>
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BFormInput,
  // BBadge,
  BButton,
  BFormTextarea,
  // BFormSpinbutton,
  BSpinner,
  BAlert,
  BFormRadio,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import store from '@/store'
import {
  URL,
  USER,
  ROLES,
  // xxx,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BRow,
    BCol,
    // BBadge,
    BButton,
    BFormInput,
    BFormTextarea,
    // BFormSpinbutton,
    BSpinner,
    BAlert,
    BFormRadio,
    BFormCheckbox,
  },
  // props: {
  //   dataPartido: Object,
  //   idEquipo: String,
  // },
  props: {
    motivoSelected: Object,
    opciones: Array,
    accion: String,
  },
  directives: {
    Ripple,
    // 'b-tooltip': VBTooltip,
    heightFade,
  },
  setup(props, { emit }) {
    const cantidad = ref(null)
    const valorUnitario = ref(null)
    const valorTotal = ref(0.0)
    const concepto = ref(null)
    const showLoading = ref(false)
    const messageError = ref(null)
    const numCuotas = ref(null)
    const dismissCountDown = ref(0)
    const variante = ref('danger')

    const dismissSecs = ref(3)
    const { postApi } = apiCall()
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      // hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function focusInput(id, error) {
      document.getElementById(id).focus()
      messageError.value = error
    }

    function hasErrorForm() {
      // console.log(concepto.value)
      // console.log(props.motivoSelected.motivo)
      let error = false
      if (
        props.motivoSelected.motivo === undefined ||
        props.motivoSelected.motivo === null ||
        props.motivoSelected.motivo === ''
      ) {
        error = true
        // messageError.value = 'Articulo no debe ser nulo'
        focusInput('floating-articulo', 'Articulo es requerido')
      } else {
        error = false
        messageError.value = ''
      }
      return error
    }
    function resetOnlyValores() {
      // messageError.value = ''
      props.motivoSelected.motivo = null
      props.motivoSelected.detalle = null
      props.motivoSelected.detalle_acta = null
      props.motivoSelected.valor = 0.0
      props.motivoSelected.total_partidos = null
      props.motivoSelected.id_opcion_baja = null
      props.motivoSelected.tipo_partido_boolean = false
      showLoading.value = false
      // countDownChanged(0)
    }
    function resetValores() {
      messageError.value = ''
      props.motivoSelected.motivo = null
      props.motivoSelected.detalle = null
      props.motivoSelected.detalle_acta = null
      props.motivoSelected.valor = null
      showLoading.value = false
      props.motivoSelected.total_partidos = null
      dismissCountDown.value = 0
      props.motivoSelected.id_opcion_baja = null
      props.motivoSelected.tipo_partido_boolean = false
      countDownChanged(0)
    }
    function onlyClose() {
      resetValores()
      store.commit('someVariables/UPDATE_SHOW_NEW_MOTIVO', false)
    }
    async function insertNuevoMotivoReglamento(accion) {
      // const data = {
      //   articulo: props.motivoSelected.motivo,
      //   valor: props.motivoSelected.valor,
      //   detalle: props.motivoSelected.detalle,
      // }
      const hasError = hasErrorForm()
      if (!hasError) {
        showLoading.value = true
        const path = `ApiSanciones/insertNuevoMotivoReglamento/${accion}`
        const response = await postApi(URL, path, props.motivoSelected)
        // console.log(response)
        if (response.flag === 'si') {
          store.commit('someVariables/UPDATE_SHOW_MULTA_GLOBAL', false)
          if (props.accion === 'i') {
            showMessageAlert('success', 'Agregado exitosamente')
          } else if (props.accion === 'u') {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'ACTUALIZADO exitosamente',
                  icon: 'AlertCircleIcon',
                  variant: 'success',
                  solid: true,
                },
              },
              {
                position: 'bottom-center',
                // eslint-disable-next-line
              }
            )
            onlyClose()
            // showMessageAlert('success', 'Actualizado exitosamente')
            // setTimeout(onlyClose, 3000)
          }
          emit('motivoAgregado')
          resetOnlyValores()
        } else {
          showMessageAlert('danger', response.mensaje)
          variante.value = 'danger'
          dismissCountDown.value = dismissSecs.value
        }
        showLoading.value = false
      } else {
        showMessageAlert('danger', 'El articulo no debe ser vacio')
      }
    }
    return {
      insertNuevoMotivoReglamento,
      concepto,
      cantidad,
      valorUnitario,
      showLoading,
      valorTotal,
      messageError,
      numCuotas,
      resetValores,
      onlyClose,
      countDownChanged,
      dismissCountDown,
      dismissSecs,
      USER,
      ROLES,
      variante,
    }
  },
}
</script>
